import React, { useEffect } from "react";
import style from "./login.module.scss";

import { createCasdoorSdkWithRedirect } from "../../config/casdoorConfig";

import MockupSignInProcess from "./MockupPages/SignInProcess";

const Login = () => {
  const checkMockup = process.env.REACT_APP_IS_MOCKUP;

  async function casdoorLogin() {
    if (checkMockup === "true") return;
    const sdk = await createCasdoorSdkWithRedirect();

    localStorage.removeItem("redirectPath");

    const signinUrl = sdk.getSigninUrl();
    window.location.href = signinUrl;
  }

  useEffect(() => {
    casdoorLogin();
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('usage_emulator_config');
  }, []);

  return (
    <>
      {
        process.env.REACT_APP_IS_MOCKUP === "true" ? (
          <MockupSignInProcess />
        ) : (
          <div className={style.redirectingCasdoor}>
            Redirecting to Nuclias Unity login...
          </div>
        )
      }
    </>
  );
};

export default Login;
